type RecorderFormat = {
  extension: string;
  mimeType: string;
};

const PREFERRED_RECORDER_FORMATS: RecorderFormat[] = [
  { mimeType: "audio/mp4;codecs=mp4a.40.2", extension: "m4a" },
  { mimeType: "audio/mp4", extension: "m4a" },
  { mimeType: "audio/aac", extension: "aac" },
  { mimeType: "audio/ogg;codecs=opus", extension: "ogg" },
  { mimeType: "audio/ogg", extension: "ogg" },
  { mimeType: "audio/webm;codecs=opus", extension: "webm" },
  { mimeType: "audio/webm", extension: "webm" },
];

const inferExtensionFromMimeType = (mimeType: string): string => {
  const normalized = mimeType.toLowerCase();
  if (normalized.includes("mp4") || normalized.includes("mp4a")) return "m4a";
  if (normalized.includes("aac")) return "aac";
  if (normalized.includes("ogg")) return "ogg";
  if (normalized.includes("mpeg") || normalized.includes("mp3")) return "mp3";
  if (normalized.includes("wav")) return "wav";
  return "webm";
};

export const getPreferredVoiceRecorderConfig = (): RecorderFormat | null => {
  if (typeof MediaRecorder === "undefined") {
    return null;
  }

  for (const format of PREFERRED_RECORDER_FORMATS) {
    if (MediaRecorder.isTypeSupported(format.mimeType)) {
      return format;
    }
  }

  return null;
};

export const createRecordedVoiceFile = (
  chunks: BlobPart[],
  mimeType?: string,
): File => {
  const resolvedMimeType = mimeType || "audio/webm";
  const extension = inferExtensionFromMimeType(resolvedMimeType);
  const blob = new Blob(chunks, {
    type: resolvedMimeType,
  });

  return new File([blob], `voice-message.${extension}`, {
    type: resolvedMimeType,
  });
};
